const roles = ['ANALISTA', 'ADMINISTRADOR', 'GESTORDECAMPANHA', 'MANUFACTURER'];

export default roles;
